import React from "react";
export const ProductOptionsFeaturesContext = React.createContext(undefined);
export function useProductOptionsFeaturesContext() {
    return React.useContext(ProductOptionsFeaturesContext) ?? { disableSwanSnowflakes: false };
}
//# sourceMappingURL=index.js.map